import type { ActiveFilter, FilterDefinition } from '@oysterjs/ui/search-filter';

import type { EmailTemplateListFieldsFragment } from '~/api/graphql';
import { BaseDateFilter, BaseSearchFilter, getSinceDate } from '~/api/data/filter-base';

export type EmailTemplateFilter = 'search' | 'date';

const templateMatchesFilter = (
  template: EmailTemplateListFieldsFragment,
  filter: ActiveFilter<EmailTemplateFilter>
): boolean => {
  switch (filter.type) {
    case 'search': {
      const searchedName = (filter.value as string).trim().toLowerCase();
      return template.name.toLowerCase().includes(searchedName);
    }
    case 'date': {
      const since = getSinceDate(filter.value as string);
      return since == null || new Date(template.updatedAt) >= since;
    }
  }
};

/** The templates that match every filter: a search by name, ignoring case, and an edit date. */
export const filterEmailTemplates = (
  templates: EmailTemplateListFieldsFragment[],
  activeFilters: ActiveFilter<EmailTemplateFilter>[]
): EmailTemplateListFieldsFragment[] =>
  templates.filter((template) =>
    activeFilters.every((filter) => templateMatchesFilter(template, filter))
  );

export const createEmailTemplateFilterDefinitions = (): FilterDefinition<EmailTemplateFilter>[] => [
  new BaseDateFilter<EmailTemplateFilter>('date'),
  new BaseSearchFilter<EmailTemplateFilter>('search')
];
